import Vue from 'vue';
import Vuetify from 'vuetify/lib';

// necesario si utilizamos la paleta de colores
//import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#dd4614' //'#fa5b00',
        // ejemplo usando paleta de colores de vuetify
        //secondary: colors.grey.darken1,
        // ...
      },
      dark: {
        // ...
      },
    },
  },
});
